import { render, staticRenderFns } from "./ModelTreeListMenu.vue?vue&type=template&id=b547b01c&scoped=true"
import script from "./ModelTreeListMenu.vue?vue&type=script&lang=ts"
export * from "./ModelTreeListMenu.vue?vue&type=script&lang=ts"
import style0 from "./ModelTreeListMenu.vue?vue&type=style&index=0&id=b547b01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b547b01c",
  null
  
)

export default component.exports